import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

type ImageSize = 'small' | 'medium' | 'large' | 'extraLarge';

const ImageSizeMap: Record<ImageSize, number> = {
  small: 55,
  medium: 60,
  large: 70,
  extraLarge: 80,
};

export const Wrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.wrapper, style],
  });

export const ImageContainer = ({ $size, style, ...props }: BoxProps & { $size?: ImageSize }) => {
  const imageSize = $size ? ImageSizeMap[$size] : ImageSizeMap.medium;

  return React.createElement(Box, {
    ...props,
    style: [styles.imageContainer, { height: imageSize, width: imageSize }, style],
  });
};

export const DetailsContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.detailsContainer, style],
  });

export const QuantityBadge = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.quantityBadge, style],
  });

export const ProductName = withTypography({
  variant: 'headerTwo',
  m: '$0',
  p: '$0',
  numberOfLines: 2,
  fontSize: 16,
  lineHeight: 22,
});

export const ProductDescription = withTypography({ variant: 'copyTwo', m: '$0', p: '$0' });

export const Layout = ({ $inline, style, ...props }: BoxProps & { $inline?: boolean }) =>
  React.createElement(Box, {
    ...props,
    style: [
      styles.layout,
      $inline ? styles.layoutInline : styles.layoutStacked,
      $inline ? styles.layoutInlineJustified : styles.layoutStackedJustified,
      style,
    ],
  });

export const SelectionsListItem = withTypography({
  fontSize: 'xs',
  lineHeight: 14,
  style: { width: '100%' },
});

const styles = StyleSheet.create({
  detailsContainer: {
    alignSelf: 'center',
    flexShrink: 1,
    justifyContent: 'center',
  },
  imageContainer: {
    justifyContent: 'center',
    margin: spacing.$0,
    marginRight: spacing.$3,
    padding: spacing.$0,
    position: 'relative',
  },
  layout: {
    alignItems: 'flex-start',
  },
  layoutInline: {
    flexDirection: 'row',
  },
  layoutInlineJustified: {
    justifyContent: 'flex-start',
  },
  layoutStacked: {
    flexDirection: 'column',
  },
  layoutStackedJustified: {
    justifyContent: 'center',
  },
  quantityBadge: {
    alignItems: 'center',
    backgroundColor: primitive.$bbqBrown,
    borderRadius: 9999,
    flexDirection: 'row',
    height: spacing.$5,
    left: -3,
    position: 'absolute',
    top: -3,
  },
  wrapper: {
    flex: 1,
  },
});
